/**
 * ToolLibraryApi
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Represents the status of a tool import job.
 */
export const ToolDataImportModuleDataContractsToolImportJobStatusDto = {
  Created: 'Created',
  Processing: 'Processing',
  Validating: 'Validating',
  Matching: 'Matching',
  WaitingForConfirmation: 'WaitingForConfirmation',
  ReadyForImport: 'ReadyForImport',
  Exporting: 'Exporting',
  Importing: 'Importing',
  Completed: 'Completed',
  Removed: 'Removed',
  Failed: 'Failed',
} as const;

export type ToolDataImportModuleDataContractsToolImportJobStatusDto =
  (typeof ToolDataImportModuleDataContractsToolImportJobStatusDto)[keyof typeof ToolDataImportModuleDataContractsToolImportJobStatusDto];
